export const SET_BECOME_CLIENT_POPUP_VARIANT = 'SET_BECOME_CLIENT_POPUP_VARIANT';
export const SET_MENU_DATA = 'SET_MENU_DATA';
